import { Suspense } from 'react';

import { logger } from '@azure/storage-blob';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { CssBaseline } from '@mui/material';
import { LicenseInfo } from '@mui/x-license-pro';
import * as Sentry from '@sentry/react';
import { APIProvider as GoogleMapApiProvider } from '@vis.gl/react-google-maps';

import './components/TailwindComponents/theme/index.css';

import { googleMapsApiKey, muiLicenseKey } from '@/config';
import { DeviceDataProvider } from '@/contexts/DeviceDataContext';

import AblyWrapper from './AblyWrapper';
import { Toast } from './components/Toast';
import { AuthProvider, ThemeProvider } from './contexts';
LicenseInfo.setLicenseKey(muiLicenseKey);

window.addEventListener('vite:preloadError', (_) => {
  logger.info('vite:preloadError', _);
  window.location.reload();
});

function App() {
  return (
    <Sentry.ErrorBoundary>
      <ErrorBoundary fallback={ErrorFallback}>
        <Suspense>
          <DeviceDataProvider>
            <ThemeProvider>
              <CssBaseline />
              <Toast />
              <AuthProvider>
                <GoogleMapApiProvider apiKey={googleMapsApiKey}>
                  <AblyWrapper />
                </GoogleMapApiProvider>
              </AuthProvider>
            </ThemeProvider>
          </DeviceDataProvider>
        </Suspense>
      </ErrorBoundary>
    </Sentry.ErrorBoundary>
  );
}

interface ErrorFallbackProps {
  resetError: () => void;
  error: Error | unknown;
}

function ErrorFallback({ resetError, error }: ErrorFallbackProps) {
  return (
    <p>
      Oops, something went wrong! <strong>{String(error)}</strong>{' '}
      <button onClick={resetError}>Retry</button>
    </p>
  );
}

export default Sentry.withProfiler(App);
